<template>
  <div class="w-full h-auto">
    <div v-if="loading" class="absolute w-full justify-center top-1/3 left-0">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 64px" spin />
      </a-spin>
    </div>

    <TotalComplaints
      :total="count"
      title="Total de Quejas"
      body="Quejas clasificadas"
    />

    <!-- Filtro de búsqueda -->
    <div>
      <div class="p-3 bg-white rounded-xl shadow-lg mx-4">
        <div class="grid grid-cols-2" @click="showFilters = !showFilters">
          <div class="flex items-center gap-4">
            <a-icon type="filter" class="text-lg ml-2"></a-icon>
            <h2 class="text-left text-lg text-gray-600">
              <b>Filtros de búsqueda</b>
            </h2>
          </div>
          <span
            class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
            :class="{ 'transform rotate-180': showFilters }"
          >
            <a-icon type="caret-down" class="text-xl my-auto" />
          </span>
        </div>
        <a-divider v-if="showFilters" class="mt-2 mb-2"></a-divider>
        <div
          class="flex gap-5 flex-wrap relative w-full border-box"
          v-show="showFilters"
        >
          <div
            @keypress.enter="!disabled || !disableButton ? onSearch() : ''"
            class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
            :class="
              management && optionsProducts.length !== 0
                ? ' xl:grid-cols-4'
                : ''
            "
          >
            <BaseSelect
              ref="company"
              id="entidad"
              label="Entidad"
              :selectOptions="formOptions.optionsCompanies"
              v-model="company"
              :loading="loading"
              :disabled="$store.state.session.user.person.position === 21"
            />
            <BaseSelect
              v-if="optionsProducts.length === 0"
              ref="product"
              id="producto "
              label="Producto"
              :selectOptions="formOptions.optionsProducts"
              v-model="form.producto_cod"
              :loading="loading"
            />
            <BaseSelect
              v-if="optionsReasons.length === 0"
              ref="reason"
              id="reason"
              label="Motivo"
              :selectOptions="formOptions.optionsReasons"
              v-model="form.macro_motivo_cod"
              :loading="loading"
            />
            <BaseSelect
              v-if="optionsProducts.length > 0"
              ref="product"
              id="producto"
              label="Producto"
              :selectOptions="optionsProducts"
              v-model="form.producto_cod"
              :loading="loading"
            />
            <BaseSelect
              v-if="optionsReasons.length > 0"
              ref="reason"
              id="reason"
              label="Motivo"
              :selectOptions="optionsReasons"
              v-model="form.macro_motivo_cod"
              :loading="loading"
            />

            <BaseInput
              type="text"
              label="Código de queja / Id. radicado"
              placeholder="Ej: 26598965472981"
              v-model="form.codigo_queja"
            />

            <BaseInput
              type="text"
              label="Palabra clave"
              placeholder="Queja, producto o motivo"
              v-model="form.search"
              v-if="!duplicate"
            />
            <BaseSelect
              ref="Instancia de recepción"
              id="Instancia de recepción"
              label="Instancia de recepción"
              :selectOptions="formOptions.optionsReception"
              v-model="form.insta_recepcion"
              v-if="!duplicate"
              :loading="loading"
            />
            <BaseRangeDate
              ref="Fecha de creacion"
              label="Fecha de creación"
              v-if="!duplicate"
              :value="
                form.start_date && form.end_date
                  ? [form.start_date, form.end_date]
                  : null
              "
              @notify-dates="setRangeDate($event)"
            />
            <BaseSelect
              ref="identificacion"
              id="identification"
              label="Tipo de identificación"
              :selectOptions="formOptions.optionsIdentificationType"
              v-model="form.tipo_id_cf"
              :loading="loading"
            />
            <BaseInput
              type="text"
              label="Nombre"
              placeholder="Ej: Fulano Lopez"
              v-model="form.nombre_cf"
            />
            <BaseInput
              type="text"
              label="Nombre del apoderado"
              placeholder="Ej: Sutano Ramirez"
              v-model="form.apoderado_nombre"
            />
            <div>
              <BaseInput
                type="text"
                label="No. de identificación"
                placeholder="Ej: 1144578546"
                v-model="form.numero_id_cf"
                :identification="form.tipo_id_cf"
                :doNotValidateNit="true"
              />
            </div>

            <div>
              <BaseInput
                ref="email_user"
                type="email_user"
                label="Correo electrónico"
                placeholder="username@example.com"
                v-model="form.email_user"
                v-if="!duplicate"
              />
              <p
                v-if="this.form.email_user != '' && feedback"
                class="mt-2 text-xs text-red-500"
              >
                {{ feedback ? feedback : "" }}
              </p>
            </div>
            <div>
              <BaseInput
                ref="emailNotification"
                type="email"
                label="Correo electrónico de notificación"
                placeholder="emailnotification@example.com"
                v-model="form.email_notification"
              />
              <p
                v-if="feedbackEmailNotification"
                class="mt-2 text-xs text-red-500"
              >
                {{ feedbackEmailNotification ? feedbackEmailNotification : "" }}
              </p>
            </div>

            <BaseSelect
              v-if="
                formOptions.optionTypeAnalisis &&
                formOptions.optionTypeAnalisis.length > 0
              "
              ref="tipoAnalisis"
              id="tipoAnalisis"
              label="Tipo de clasificación"
              :selectOptions="customTypeAnalisis"
              v-model="form.tipo_analisis"
              :loading="loading"
            />

            <BaseSelect
              v-if="
                formOptions.optionTypeMlValidation &&
                formOptions.optionTypeMlValidation.length > 0
              "
              ref="validacionClasificacion"
              id="validacionClasificacion"
              label="Validación de clasificación ML"
              :selectOptions="formOptions.optionTypeMlValidation"
              v-model="form.is_derecho_peticion_usuario"
              :loading="loading"
            />

            <div>
              <BaseRadio
                id="habeas_data"
                :name="'habeas_data'"
                label="Queja relacionada con motivo de habeas data"
                :radioOptions="[
                  { id: true, name: 'Sí' },
                  { id: false, name: 'No' },
                ]"
                v-model="form.check_habeas_data"
              />
            </div>
          </div>
          <div class="w-full flex justify-end self-end gap-4">
            <a-button
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              type="danger"
              ghost
              shape="round"
              @click="clearFilters"
            >
              Limpiar
            </a-button>

            <a-button
              :loading="(searching = loading)"
              type="primary"
              shape="round"
              @click="onSearch"
              class="w-1/2 gap-2 sm:mt-auto mt-3 lg:w-1/6"
              :disabled="disableButton && disabled"
            >
              <a-icon type="search" v-if="!searching"></a-icon>
              {{ searching ? "BUSCANDO..." : "BUSCAR" }}
            </a-button>
          </div>
        </div>
      </div>

      <div v-if="management" class="my-8 mx-4 max-w-sm rounded-xl">
        <a-button
          type="primary"
          shape="round"
          @click.native="openModal"
          :block="true"
        >
          CREAR MUESTRA
        </a-button>
      </div>
      <Modal v-if="showModal">
        <div class="w-full px-4 flex justify-end items-center">
          <a-icon
            type="plus"
            class="text-2xl ml-auto transform text-gray-600 rotate-45"
            @click.native="closeModal"
          />
        </div>
        <div class="pb-4 flex flex-col justify-center items-center">
          <div class="mb-4 w-full max-w-md text-left">
            <h2 class="mb-2 text-2xl text-blue-dark"><b>Crear muestra</b></h2>
            <p class="text-md pb-0">
              Selecciona los datos para crear la muestra de monitoreo
            </p>
            <div class="w-full pb-4">
              <BaseSelect
                label="Entidad"
                :selectOptions="formOptions.optionsCompanies"
                v-model="sample_form.control_entity"
              />
              <BaseSelect
                label="Tipo de criterio a evaluar"
                :selectOptions="formOptions.optionsCriterions"
                v-model="sample_form.criterion"
              />
              <BaseNumber
                label="Cantidad de muestra"
                placeholder="Ej: 200"
                v-model="sample_form.sample_size"
              />
            </div>
          </div>

          <div class="w-full max-w-md flex flex-col gap-4">
            <a-button
              type="primary"
              :block="true"
              shape="round"
              @click.native="createSample"
            >
              CREAR MUESTRA
            </a-button>
            <a-button
              type="danger"
              :block="true"
              shape="round"
              ghost
              @click.native="closeModal"
            >
              CANCELAR
            </a-button>
          </div>
        </div>
      </Modal>
    </div>

    <!-- Descarga de anexos -->
    <div class="mt-4">
      <div class="p-3 bg-white rounded-xl shadow-lg mx-4">
        <div class="grid grid-cols-2" @click="showDownload = !showDownload">
          <div class="flex items-center gap-4">
            <a-icon type="download" class="text-lg ml-2"></a-icon>
            <h2 class="text-left text-lg text-gray-600">
              <b>Descarga de anexos</b>
            </h2>
          </div>
          <span
            class="h-5 w-5 m-2 flex justify-center items-center transition justify-self-end"
            :class="{ 'transform rotate-180': showDownload }"
          >
            <a-icon type="caret-down" class="text-xl my-auto" />
          </span>
        </div>
        <a-divider v-if="showDownload" class="mt-2 mb-2"></a-divider>
        <div
          class="flex gap-2 flex-wrap relative w-full border-box pb-4 px-4 pt-4"
          v-show="showDownload"
        >
          <template v-if="showDownloadOption">
            <div
              class="col-span-1 sm:col-span-2 md:col-span-3 mb-2 italic text-gray-500"
            >
              La descarga masiva se generará con base en los filtros
              seleccionados en el componente de búsqueda al momento de iniciar
              el proceso.
            </div>

            <div
              @keypress.enter="!disabled || !disableButton ? onSearch() : ''"
              class="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-2 relative"
              :class="
                management && optionsProducts.length !== 0
                  ? ' xl:grid-cols-3'
                  : ''
              "
            >
              <BaseMultiSelect
                title="Selección de formatos de archivo para exportar anexos"
                :valuesSelected="fileTypeSelection"
                :defaultValues="fileTypeSelected"
                :data="optionsFileType"
                label="name"
                @notify-objects="setMultiSelect($event)"
              />

              <a-button
                :loading="searching || loadingAnnexes"
                type="primary"
                shape="round"
                @click="onRetrieveAnnexes(true)"
                class="w-max gap-2 sm:mt-auto mt-3 md:ml-8"
                :disabled="disableButton && disabled"
              >
                <a-icon type="download"></a-icon>
                INICIAR DESCARGA MASIVA
              </a-button>
            </div>
          </template>

          <template v-if="showDownloadProgress">
            <div
              class="w-full flex flex-col md:flex-row items-center gap-8 py-2 px-4"
            >
              <div class="flex flex-col items-center relative">
                <a-progress
                  type="circle"
                  :percent="processPercent"
                  :stroke-width="8"
                  stroke-color="#1890ff"
                  :width="160"
                >
                  <template #format="percent">
                    <div class="flex flex-col items-center justify-center">
                      <span class="text-4xl font-bold text-gray-800"
                        >{{ percent }}%</span
                      >
                      <span class="text-gray-500 text-sm">Completado</span>
                    </div>
                  </template>
                </a-progress>
              </div>

              <div class="flex-1 w-full max-w-xl text-left">
                <h3 class="text-xl font-semibold text-blue-600 mb-1 text-left">
                  Procesando {{ processedFiles }} de {{ totalFiles }} archivos
                  anexos
                </h3>
                <p class="text-gray-500 text-base text-left">
                  Esto proceso puede tardar unos minutos
                </p>
                <a-button
                  class="mt-4"
                  type="danger"
                  ghost
                  shape="round"
                  @click="cancelDownload"
                >
                  Cancelar descarga
                </a-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <div
      class="bg-white rounded-xl border border-gray-300 mt-4 ml-4 search-complaints"
    >
      <header
        class="header-derechos-peticion mb-4 flex flex-col-reverse items-center justify-center lg:flex-row lg:justify-end gap-3"
      >
        <a-dropdown class="mt-7 ml-5">
          <a-button
            type="primary"
            shape="round"
            @click="collapsed = !collapsed"
          >
            <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
          </a-button>
          <template #overlay>
            <!-- @click="handleMenuClick" -->
            <a-menu>
              <a-menu-item @click="downloadReport(1, 'xlsx')" key="xlsx">
                <a-icon
                  type="upload"
                  :style="{ fontSize: '16px' }"
                  class="mr-2"
                />
                .xlsx
              </a-menu-item>
              <a-menu-item @click="downloadReport(1, 'csv')" key="csv">
                <a-icon
                  type="upload"
                  :style="{ fontSize: '16px' }"
                  class="mr-2"
                />
                .csv (Separado por comas)
              </a-menu-item>
              <a-menu-item @click="downloadReport(1, 'txt')" key="txt">
                <a-icon
                  type="upload"
                  :style="{ fontSize: '16px' }"
                  class="mr-2"
                />
                .txt
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </header>

      <a-table
        class="table-component"
        :columns="columns"
        :data-source="data"
        :pagination="false"
        :scroll="{ x: '1220px' }"
      >
        <span slot="nombre_cf" slot-scope="text, record">{{
          record.nombre_cf
        }}</span>
        <span slot="entidad" slot-scope="text, record">{{
          record.entidad
        }}</span>
        <span slot="codigo_queja" slot-scope="text, record">
          {{ record.codigo_queja }}
        </span>
        <span slot="texto_queja" slot-scope="text, record">
          {{ `${record.texto_queja.substring(0, 30)}...` }}
        </span>

        <span slot="tipo_analisis" slot-scope="text, record">
          <TypeAnalisisLabel :label="record.tipo_analisis" />
        </span>
        <span slot="is_derecho_peticion_usuario" slot-scope="text, record">
          <TypeMlValidationLabel :status="record.is_derecho_peticion_usuario" />
        </span>

        <!-- @click="goToReportDetail(record.document_id)" -->
        <div
          class="flex justify-evenly align-center"
          slot="action"
          slot-scope="text, record"
        >
          <button
            class="text-sm text-blue h-min flex items-center"
            @click="goDetail(record)"
          >
            <a-icon
              class="mr-2"
              type="eye"
              theme="twoTone"
              two-tone-color="#3366cc"
              :style="{ fontSize: '22px' }"
            />
            &nbsp;
            <span>Ver</span>
          </button>
          <template v-if="record.tiene_anexos">
            <button
              class="text-sm text-blue h-min flex items-center ml-2"
              @click="downloadAnnex(record)"
            >
              <a-icon
                class="mr-2"
                type="download"
                :style="{ fontSize: '22px', color: '#3366cc' }"
              />
              &nbsp;
              <span>Descargar anexos</span>
            </button>
          </template>
        </div>
      </a-table>
      <!-- PAGINACIÓN AGREGADA -->
      <div class="p-4 flex justify-end">
        <a-pagination
          v-model="page"
          :page-size="pageSize"
          :page-size-options="pageSizeOptions"
          :total="count"
          show-size-changer
          size="large"
          @showSizeChange="onShowSizeChange"
          @change="onPageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TableComponent from "@/components/UI/Table/TableComponent.vue";
import ClassificationServicesImpl from "@/feature/clasification/data/services/derechos_peticion_services";
import SharedServicesImpl from "@/feature/shared/data/services/shared_services";
import TotalComplaints from "@/components/Dashboard/Complaints/TotalComplaints.vue";
import TypeAnalisisLabel from "@/feature/shared/presentation/partials/TypeAnalisisLabel.vue";
import TypeMlValidationLabel from "@/feature/shared/presentation/partials/TypeMlValidationLabel.vue";
import moment from "moment";
import { db } from "@/firebase/config";
import ErrorMessaje from "@/core/error/error_messaje";
import {
  collection,
  doc,
  onSnapshot,
  query,
  orderBy,
  getDoc,
} from "firebase/firestore";

const columns = [
  {
    slots: { title: "nombre_cf" },
    title: "Nombre del CF",
    dataIndex: "nombre_cf",
    key: "nombre_cf",
    scopedSlots: { customRender: "nombre_cf" },
  },
  {
    slots: { title: "entidad" },
    title: "Entidad",
    dataIndex: "entidad",
    key: "entidad",
    scopedSlots: { customRender: "entidad" },
  },
  {
    slots: { title: "codigo_queja" },
    title: "Código de queja",
    dataIndex: "codigo_queja",
    key: "codigo_queja",
    scopedSlots: { customRender: "codigo_queja" },
  },
  {
    slots: { title: "texto_queja" },
    title: "Contexto",
    dataIndex: "texto_queja",
    key: "texto_queja",
    scopedSlots: { customRender: "texto_queja" },
  },
  {
    slots: { title: "tipo_analisis" },
    title: "Tipo de clasificación",
    dataIndex: "tipo_analisis",
    key: "tipo_analisis",
    scopedSlots: { customRender: "tipo_analisis" },
  },
  {
    slots: { title: "is_derecho_peticion_usuario" },
    title: "Validación de clasificación ML",
    dataIndex: "is_derecho_peticion_usuario",
    key: "is_derecho_peticion_usuario",
    scopedSlots: { customRender: "is_derecho_peticion_usuario" },
  },
  {
    slots: { title: "action" },
    title: "Acciones",
    dataIndex: "action",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 250,
  },
];

export default {   
  props: ["management", "query", "duplicate"],
  components: {
    TableComponent,
    TotalComplaints,
    TypeAnalisisLabel,
    TypeMlValidationLabel,
  },
  data() {
    return {
      loading: false,
      count: 0,
      filterSearch: "",
      page: 1,
      pageSize: 50,
      pageSizeOptions: ["50", "100", "150", "200", "250"],
      columns: columns,
      data: [],
      form: {},
      company: "",
      optionsProducts: [],
      fileTypeSelected: [],
      fileTypeSelection: [],
      optionsFileType: [
        { id: 1, name: "pdf" },
        { id: 2, name: "eml" },
        { id: 3, name: "msg" },
        { id: 4, name: "jpeg" },
        { id: 5, name: "png" },
        { id: 6, name: "jpg" },
        { id: 7, name: "docx" },
        { id: 8, name: "mp3" },
        { id: 9, name: "xlsx" },
        { id: 10, name: "mp4" },
        { id: 11, name: "doc" },
        { id: 12, name: "xls" },
      ],
      optionsFavorability: [
        { name: "Favorable", id: 1 },
        { name: "Parcialmente Favorable", id: 2 },
        { name: "No Favorable", id: 3 },
      ],
      optionsReasons: [],
      productValue: "",
      reasonValue: "",
      favorabilityValue: "",
      sample_form: {
        control_entity: "",
        criterion: "",
        sample_size: "",
      },
      showModal: false,
      feedback: "",
      searching: false,
      disableButton: true,
      showFilters: false,
      showDownload: false,
      oldFilters: {},
      // descargas componente
      collapsed: false,
      loadingReport: false,
      feedbackEmailNotification: "",
      unsubscribe: null,
      userId: null,
      docId: null,
      totalFiles: 0,
      processedFiles: 0,
      processPercent: 0,
      processText: "",
      showDownloadOption: true,
      showDownloadProgress: false,
      loadingAnnexes: false,
    };
  },
  watch: {
    company: async function (value) {
      if (value == "") {
        this.form.entidad_cod = "";
        this.form.tipo_entidad = "";
        this.optionsProducts = [];
        this.optionsReasons = [];
        return;
      }
      this.productValue = "";
      this.reasonValue = "";
      let optionsProducts = await this.$store.dispatch(
        "form/loadProductsOptions",
        { company: this.company },
      );

      let optionsReasons = await this.$store.dispatch(
        "form/loadReasonsOptions",
        { company: this.company },
      );
      const companyData = this.$store.state.form.optionsCompanies.find(
        (item) => item.id == this.company,
      );

      this.form.company_sfc_code = companyData.sfc_code;
      this.form.tipo_entidad = companyData.company_type;
      this.optionsProducts = optionsProducts ? optionsProducts : [];
      this.optionsReasons = optionsReasons ? optionsReasons : [];
    },
  },

  methods: {
    async getReports() {
      this.loading = true;
      // Modificar para incluir paginación
      const params = {
        ...this.form,
        page: this.page,
        page_size: this.pageSize,
      };
      const { data } = await ClassificationServicesImpl.getClassifitionBySearch(
        params,
      );
      this.data = data.data;
      this.count = data.count;
      this.loading = false;
    },
    async getRetrieveUserCompressions() {
      try {
        const response = await SharedServicesImpl.getRetrieveUserCompressions();

        if (response.isSuccess) {
          if (
            response.data.data &&
            response.data.data.peticion &&
            response.data.data.peticion.length > 0
          ) {
            this.docId = response.data.data.peticion[0].id;
            // Centralized monitoring
            this.$root.$emit("start-async-process", {
              docId: this.docId,
              name: "Descarga de anexos - Derechos de Petición",
              type: "peticion",
            });
            this.setupFirestoreListener();
            this.showToast("info", "Descarga de anexos restablecida");
            this.showDownload = true;
            this.showDownloadOption = false;
            this.showDownloadProgress = true;
          }
          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.message) {
            errorMessage = response.data.message;
          }
          this.showToast("error", errorMessage);
          return;
        }
      } catch (error) {
        this.showToast("error", ErrorMessaje.internalServerError);
      }
    },
    async downloadReport(type, classFile) {
      const params = { ...this.form, class_type: type, get_file: classFile };

      this.showNotification("Generando reporte");
      const { data } = await ClassificationServicesImpl.getReportClassifition(
        params,
      );

      const nameFile = "reporte.xlsx";
      const downloadLink = document.createElement("a");
      downloadLink.href = data.url;
      downloadLink.download = nameFile;
      downloadLink.click();
    },
    goDetail(record) {
      const id = record.codigo_queja;
      const documentoId = record.documento_id;
      this.$router.push({
        path: `/dashboard/classification/right_request/detail/${id}/${documentoId}`,
        query: {
          is_derecho_peticion_usuario: record.is_derecho_peticion_usuario,
          tipo_analisis: record.tipo_analisis,
        },
      });
    },
    async onRetrieveAnnexes(isDownloadMasive) {
      this.loadingAnnexes = true;
      if (this.fileTypeSelected.length === 0) {
        this.showNotification(
          "Debe seleccionar al menos un formato de archivo para la exportación de anexos.",
        );
        this.loadingAnnexes = false;
        return;
      }

      if (isDownloadMasive) {
        this.form.complaint_doc_id = null;
      }

      //  classification_type -	1 -> Derechos de petición; 2 -> Habeas Data.
      this.form.classification_type = 1;

      // A partir de fileTypeSelected, obtener los nombres de los tipos de archivo seleccionados y agregarlos a form.download_file_type
      this.form.download_file_type = this.fileTypeSelected
        .map((id) => this.optionsFileType.find((opt) => opt.id === id)?.name)
        .filter((name) => name) // Filtra valores undefined si no se encuentra el ID
        .join(",");

      try {
        const response = await SharedServicesImpl.getRetrieveAnnexes(this.form);

        if (response.isSuccess) {
          if (isDownloadMasive) {
            this.docId = response.data.data.doc_id;
          } else {
            this.docId = response.data.doc_id;
          }

          // Centralized monitoring
          this.$root.$emit("start-async-process", {
            docId: this.docId,
            name: "Descarga de anexos - Derechos de Petición",
            type: "peticion",
          });

          // Iniciar listener ANTES de mostrar el progreso para capturar estados iniciales
          this.setupFirestoreListener();

          this.showToast(
            "info",
            "Proceso de descarga de anexos iniciado correctamente.",
          );
          this.showDownloadOption = false;
          this.showDownloadProgress = true;
          this.loadingAnnexes = false;
          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.message) {
            errorMessage = response.data.message;
          }
          this.showToast("error", errorMessage);
          this.loadingAnnexes = false;
          return;
        }
      } catch (error) {
        this.loadingAnnexes = false;
        this.showToast("error", ErrorMessaje.internalServerError);
      }
    },
    async onSearch() {
      this.loading = true;
      if (
        this.form.email_notification &&
        this.form.email_notification !== "" &&
        !/^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i.test(
          this.form.email_notification,
        )
      ) {
        this.feedbackEmailNotification =
          "Por favor, verifique el correo electrónico.";
        this.loading = false;
        return;
      } else {
        this.feedbackEmailNotification = "";
      }
      if (this.form.email_user && this.form.email_user !== "") {
        if (
          /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\]\.,;:\s@"]{2,63}$/i.test(
            this.form.email_user,
          )
        ) {
          this.feedback = "";
        } else {
          this.feedback = "Por favor, verifique el correo electrónico.";
          this.loading = false;
          return;
        }
      }
      this.page = 1; // Reiniciar a la primera página al buscar
      await this.getReports();
      this.loading = false;
    },
    setRangeDate(eventValue) {
      this.form.start_date = eventValue ? eventValue[0] : "";
      this.form.end_date = eventValue ? eventValue[1] : "";
      this.disableButton = false;
    },
    // TODO: Modificar entidad_code
    getCompany() {
      // if (this.form.entidad_cod && this.form.entidad_cod !== "") {
      //   const companyData = this.$store.state.form.optionsCompanies.find(
      //     (item) =>
      //       item.sfc_code == this.form.entidad_cod &&
      //       item.company_type == this.form.tipo_entidad
      //   );
      //   this.company = companyData.id + "";
      // }
    },
    clearFilters() {
      this.initializeForm();
      this.page = 1;
      this.getReports();
    },
    initializeForm() {
      this.form = {
        tipo_entidad: "",
        producto_cod: "",
        macro_motivo_cod: "",
        codigo_queja: "",
        insta_recepcion: "",
        start_date: moment(new Date()).subtract(7, "days").format("YYYY-MM-DD"),
        end_date: moment(new Date()).format("YYYY-MM-DD"),
        tipo_id_cf: "",
        nombre_cf: "",
        apoderado_nombre: "",
        numero_id_cf: "",
        email_user: "",
        check_habeas_data: "",
        search: "",
        company_sfc_code: "",
        address: "",
        email_notification: "",
        tipo_analisis: "",
        is_derecho_peticion_usuario: "",
        classification_type: "",
        complaint_doc_id: "",
        download_file_type: "",
      };
      this.setCompanyForEV();
    },
    setCompanyForEV() {
      this.company =
        this.$store.state.session.user.person.position == 21
          ? `${this.$store.state.session.user.id_company.id || ""}`
          : "";
    },
    async createSample() {
      const { sample_size, control_entity, criterion } = this.sample_form;
      const body = {
        sample_quantify: parseInt(sample_size),
        entities: [parseInt(control_entity)],
        criterion: parseInt(criterion),
      };

      this.loading = true;
      let { error, data } = await this.$api.createSample(body);
      this.loading = false;

      if (error) this.showNotification(error.message);

      if (data) {
        this.showNotification("Muestra creada");
        this.$router.push(`/dashboard/complaints/management/samples`);
      }
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    showNotification(message) {
      this.$notification.open({
        // message: "Notificación",
        description: message,
      });
    },
    showToast(result = "info", msg) {
      this.$notification[result]({
        message: "Resultado",
        description: msg,
        onClick: () => {},
      });
    },
    onShowSizeChange(current, size) {
      this.pageSize = size;
      this.page = 1;
      this.getReports();
    },
    onPageChange(page) {
      this.page = page;
      this.getReports();
    },
    async downloadAnnex(record) {
      this.form.complaint_doc_id = record.documento_id;
      const isDownloadMasive = false;
      await this.onRetrieveAnnexes(isDownloadMasive);
    },
    setMultiSelect(ev) {
      this.fileTypeSelected = ev.map((item) => item.id);
    },
    async setupFirestoreListener() {
      if (!this.userId || !this.docId) {
        console.warn("Faltan parámetros para setupFirestoreListener", {
          userId: this.userId,
          docId: this.docId,
        });
        return;
      }

      if (this.unsubscribe) {
        this.unsubscribe();
      }

      // Asegurar que los IDs sean strings y no contengan slashes accidentales o sean nulos
      const uId = String(this.userId).trim();
      const dId = String(this.docId).trim();

      if (!uId || !dId) {
        console.error("IDs inválidos después de conversión", { uId, dId });
        return;
      }

      const docRef = doc(db, "sfc-annex-compression", uId, "jobs", dId);

      // Verificación inicial inmediata con getDoc para procesos ultra rápidos
      try {
        const snap = await getDoc(docRef);
        if (snap.exists()) {
          const data = snap.data();
          if (data.status === "finished" || data.url) {
            this.handleDownloadFinished(data);
            return; // No necesitamos suscribirnos si ya terminó
          }
        }
      } catch (err) {
        console.error("Error en verificación inicial:", err);
      }

      // Suscripción para cambios en tiempo real
      try {
        this.unsubscribe = onSnapshot(
          docRef,
          (snap) => {
            if (!snap.exists()) {
              console.log("Documento aún no existe, esperando...");
              return;
            }

            const data = snap.data();
            this.processedFiles = Number(data.processed_files) || 0;
            this.totalFiles = Number(data.count) || 0;

            if (data.status === "finished" || data.url) {
              this.handleDownloadFinished(data);
            } else if (data.status === "error") {
              this.showToast(
                "error",
                "Ocurrió un error en el proceso de compresión.",
              );
              this.showDownloadOption = true;
              this.showDownloadProgress = false;
              if (this.unsubscribe) this.unsubscribe();
            } else {
              this.processPercent = this.totalFiles
                ? Math.round((this.processedFiles / this.totalFiles) * 100)
                : 0;
              this.processText = `Procesando ${this.processedFiles} de ${this.totalFiles} archivos anexos...`;
            }
          },
          (err) => {
            console.error("Firestore error:", err);
            this.showToast("error", `Error de seguimiento: ${err.message}`);
          },
        );
      } catch (err) {
        console.error("Error al inicializar Firestore listener:", err);
      }
    },
    onAsyncProcessFinished(payload) {
      if (payload.id === this.docId) {
        this.handleDownloadFinished(payload);
      }
    },
    onAsyncProcessCancelled(payload) {
      if (payload.id === this.docId) {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
        this.processPercent = 0;
        this.processedFiles = 0;
        this.totalFiles = 0;
        this.showDownloadOption = true;
        this.showDownloadProgress = false;
        this.loadingAnnexes = false;
      }
    },
    handleDownloadFinished(data) {
      this.processPercent = 100;
      this.processedFiles = Number(data.count) || this.totalFiles;
      this.processText = "Descarga lista.";

      if (data.url) {
        if (!window[`downloaded_${data.id}`]) {
          window[`downloaded_${data.id}`] = true;
          const link = document.createElement("a");
          link.href = data.url;
          link.setAttribute("download", `anexos_${this.docId}.zip`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          // this.showToast("success", "La descarga ha comenzado automáticamente.");
        }

        // Volver al estado inicial después de un tiempo
        setTimeout(() => {
          this.showDownloadOption = true;
          this.showDownloadProgress = false;
          if (this.unsubscribe) this.unsubscribe();
          delete window[`downloaded_${data.id}`];
        }, 3000);
      }
    },
    async cancelDownload() {
      if (this.unsubscribe) {
        this.unsubscribe();
        this.unsubscribe = null;
      }

      const payload = {
        document_id: this.docId,
      };

      try {
        const response = await SharedServicesImpl.cancelCompressJob(payload);

        if (response.isSuccess) {
          this.showToast("info", "Descarga cancelada.");

          this.processPercent = 0;
          this.processedFiles = 0;
          this.totalFiles = 0;
          this.showDownloadOption = true;
          this.showDownloadProgress = false;
          this.loadingAnnexes = false;

          // Detener el seguimiento global en el monitor del encabezado
          this.$root.$emit("stop-async-process");

          return;
        } else {
          let errorMessage = ErrorMessaje.generalError;
          if (response.data && response.data.message) {
            errorMessage = response.data.message;
          }
          this.showToast("error", errorMessage);
          this.loadingAnnexes = false;
          return;
        }
      } catch (error) {
        this.loadingAnnexes = false;
        this.showToast("error", ErrorMessaje.internalServerError);
      }
    },
  },
  computed: {
    formOptions: function () {
      return this.$store.state.form;
    },
    customTypeAnalisis: function () {
      return this.$store.state.form?.optionTypeAnalisis?.filter(
        (optionTypeAnalisis) => optionTypeAnalisis.id !== "Casilla",
      );
    },
    disabled: function () {       
      return false;
    },
  },
  created() {
    this.userId = this.$store.state.session.user.id;

    this.initializeForm();
    this.getReports();
    this.fileTypeSelection = [...this.optionsFileType];
    this.fileTypeSelected = this.optionsFileType.map((item) => item.id);
    setTimeout(() => {
      this.getCompany();
    }, 1500);
    this.getRetrieveUserCompressions();

    this.$root.$on("async-process-finished", this.onAsyncProcessFinished);
    this.$root.$on("async-process-cancelled", this.onAsyncProcessCancelled);
  },
  beforeDestroy() {
    this.$root.$off("async-process-finished", this.onAsyncProcessFinished);
    this.$root.$off("async-process-cancelled", this.onAsyncProcessCancelled);
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  },
};
</script>

<style scoped>
.header-derechos-peticion {
  justify-content: flex-start !important;
}

.header-derechos-peticion ul {
  border-bottom: none !important;
  background: none !important;
}

button {
  border-radius: 5px;
}

.flex-wrap {
  flex-wrap: wrap;
}

.p-10 {
  padding: 10px;
}

.d-flex {
  display: flex;
}

.flex-center {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.ms-auto {
  margin-left: auto;
}

.btn-large {
  min-width: 300px;
}

.btn-small {
  min-width: 90px;
  padding: 3px;
}

.btn-white {
  box-shadow: 0 0 2mm #e7e7e7;
}

.btn-square {
  width: 40px;
  height: 40px;
}

.btn-square-small {
  width: 26px;
  height: 26px;
}

.btn-gray {
  background: #e7e7e7;
  color: black;
}

.btn-primary {
  background: #004884;
  color: white;
}

.btn-warning {
  background: #f8b446;
  color: white;
}

.btn-danger {
  background: #ea4a76;
  color: white;
}

.btn-success {
  background: #309d7e;
  color: white;
}

.btn-warning-light {
  background: #fff3e0;
  color: #f8b446;
}

.btn-danger-light {
  background: #ffedf2;
  color: #ea4a76;
}

.btn-primary-light {
  background: #edf3ff;
  color: #004884;
}

.btn-success-light {
  background: #e5fbf5;
  color: #309d7e;
}

.no-border {
  border: 0px !important;
}

.border-bottom-gray {
  border-bottom: 1px solid #e7e7e7;
}

.flag {
  min-width: 90px;
  display: flex;
  padding: 5px;
  border-radius: 5px;
  flex-wrap: wrap;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.search > input {
  border: 1px solid;
  border-radius: 10px;
  min-width: 400px;
  margin-right: 10px;
  padding: 0px 10px;
}

.search > button {
  border-radius: 10px;
}

.table {
  padding: 10px;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  flex-wrap: wrap;
}

.tableHeader {
  font-weight: bold;
}

.table > div {
  flex-wrap: wrap;
}

.table > div > div {
  border-bottom: 1px solid black;
  padding: 10px 1px;
}

.progressbar {
  height: 26px;
  border-radius: 5px;
  background: #e5fbf5;
  display: flex;
  justify-content: start;
  align-content: center;
  align-items: center;
}

.progressbar > div {
  height: 26px;
  color: white;
  border-radius: 5px;
  background: #309d7e;
  width: 50%;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.w-100 {
  width: 100%;
}

.w-90 {
  width: 90%;
}

.w-80 {
  width: 80%;
}

.w-70 {
  width: 70%;
}

.w-60 {
  width: 60%;
}

.w-50 {
  width: 50%;
}

.w-45 {
  width: 45%;
}

.w-40 {
  width: 40%;
}

.w-35 {
  width: 35%;
}

.w-30 {
  width: 30%;
}

.w-25 {
  width: 25%;
}

.w-20 {
  width: 20%;
}

.w-15 {
  width: 15%;
}

.w-10 {
  width: 10%;
}

.w-5 {
  width: 5%;
}
</style>
